//enum
export enum ALIGNMENT_TYPE {
  LEFT,
  RIGHT,
}

export enum RADIO_TYPE {
  LIST = 'list',
  DEFAULT = 'default',
}

//types
export interface Value {
  id: string;
  name: string;
  productCount?: number;
  color_code?: string;
  color_image?: string;
  letterHeading?: string;
  alphabet?: string;
  values?: Value[];
  parent_id?: string;
  level?: string;
  children?: Value[];
  show_select_all?: boolean;
}
